import { InternalServerErrorException } from '../../../../common/exceptions/exceptions';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { GetAccountCallsSummaryApplicationService } from '../../../../core/application/services/org-metrics/calls/get-account-calls-summary.application-service';
import { AccountCallsSummaryAggregateRoot } from '../../../../core/domain/aggregates/org-metrics/account-calls-summary.aggregate-root';
import { GetAccountCallsSummaryRequestDto } from '../../../dtos/org-metrics/calls/get-account-calls-summary-request.dto';

export class GetAccountCallsSummaryQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetAccountCallsSummaryApplicationService
  ) {}

  async execute(
    props: GetAccountCallsSummaryRequestDto
  ): Promise<AccountCallsSummaryAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
